import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import client from '../sanityClient';
import BlogCard from './CategoryBlogCard';
import { motion } from 'framer-motion';

const CategoryPage = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const { category } = useParams();

    const formattedCategory = category
        .replace(/-/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase());

    useEffect(() => {
        const fetchBlogs = async () => {
            setLoading(true);

            try {
                const data = await client.fetch(
                    `*[_type == "post" && $category in categories[]->title || title match "*${formattedCategory}*"]{
                        title,
                        slug,
                        mainImage {
                            asset -> {
                                _id,
                                url
                            },
                            alt,
                        },
                        publishedAt,
                        author-> {
                            name,
                            image {
                                asset -> {
                                    url
                                }
                            }
                        },
                        categories[]-> {
                            title
                        }
                    } | order(publishedAt desc)`,
                    { category: formattedCategory }
                );

                setBlogs(data);
            } catch (error) {
                console.error('Error fetching blogs:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, [formattedCategory]);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <motion.div
                    className="rounded-full h-32 w-32 border-t-4 border-b-4 border-blue-500"
                    animate={{ rotate: 360 }}
                    transition={{
                        repeat: Infinity,
                        duration: 1.5,
                        ease: 'linear'
                    }}
                />
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold mb-8 text-center">{formattedCategory} Blogs</h1>
            {blogs.length === 0 ? (
                <p className="text-center text-gray-600">No data found.</p>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {blogs.map((blog) => (
                        blog.slug && blog.slug.current ? (
                            <div key={blog.slug.current}>

                                <BlogCard blog={blog} />
                            </div>
                        ) : null
                    ))}
                </div>
            )}
        </div>
    );
};

export default CategoryPage;
